import styled from "styled-components";

export const WrapperItems = styled.div`
  max-height: 300px;
  overflow-y: auto;
`;